import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  TextField,
  SwitchField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// A spec a car can be built to, offered to clients when they add a car.
export default class VehicleSpecForm extends React.Component {
  constructor(props) {
    super(props);
    const spec = props.item || {};
    this.state = {
      id: spec.id || "",
      version: spec.version,
      name: spec.name || "",
      isActive: spec.id ? !!spec.isActive : true,
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const errors = {};
    if (`${this.state.name}`.trim().length < 2) {
      errors.name = strings.name_min_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, name, isActive } = this.state;
    this.setState({ loading: true, error: "", errors: {} });

    const payload = { name: `${name}`.trim(), isActive };

    try {
      const response = id
        ? await this.engine.updateItem("vehicle-specs", id, {
            ...payload,
            version,
          })
        : await this.engine.saveItem("vehicle-specs", payload);

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { name, isActive, loading, error, errors } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.vehicle_spec} icon="nc-icon nc-delivery-fast">
          <FormGrid full>
            <TextField
              label={strings.name}
              required
              help={strings.vehicle_spec_name_hint}
              value={name}
              onChange={(value) => this.setState({ name: value })}
              error={errors.name}
            />
          </FormGrid>

          <SwitchField
            label={strings.active}
            help={strings.vehicle_spec_active_hint}
            checked={isActive}
            onChange={(checked) => this.setState({ isActive: checked })}
          />
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
